<template>
	<div>
		<select name="SelectTimezone" id="SelectTimezone" v-model="selectedTimeZone">
			<option :value="option" v-for="option in timezones">{{option}}</option>
		</select>
	</div>
</template>


<script>
'use strict';


	export default {
		name: 'SelectTimezone',
		data() {
			return {
				
			}
		},

		methods: {

		},

		computed: {
			timezones() {
				return this.$store.getters.timezones;
			},

			selectedTimeZone : {
				get() {
					return this.$store.getters.selectedTimezone;
				},
				set(value) {
					return this.$store.dispatch('SET_SELECTED_TIMEZONE', value);
				}
			}
		},

		components: {

		},

		beforeMount() {

		},

		mounted() {
			
		},
		created() {
			this.$store.dispatch('GET_SELECTED_TIMEZONE')
			this.$store.dispatch('GET_TIMEZONES');
		}

	}	
</script>



<style>

[v-cloak] {
	display: none;
}

	
</style>